import * as Yup from 'yup';
// import { yupResolver } from "@hookform/resolvers/yup";
// import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import UserTextInput from 'components/UserInput/UInput';
import { useForm } from 'react-hook-form';
import { ForgetPassword, useForgetPassword } from 'redux/reducers/user/dashboard/tms-auth';
import PrimaryButton from 'components/ui/PrimaryButton';
import { toast } from 'react-toastify';
import { BiCloset, BiLock } from 'react-icons/bi';
import { MdClose } from 'react-icons/md';

interface IForgotPasswordModal {
  openForgetPasswordModal: boolean;
  handleClose: () => void;
}

const defaultValues = {
  email: ''
};

const ForgotPasswordModal = ({ openForgetPasswordModal, handleClose }: IForgotPasswordModal) => {
  const { mutateAsync, isLoading } = useForgetPassword();

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required')
  });
  const { handleSubmit, control } = useForm({
    defaultValues: defaultValues
    // resolver: validationSchema
  });

  const submitHandler = async (email: ForgetPassword) => {
    try {
      await mutateAsync(email);
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };
  return (
    <>
      <Dialog
        open={openForgetPasswordModal}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 3,
            width: '100%',
            maxWidth: 480,
            p: { xs: 1, sm: 2 }
          }
        }}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 12,
              top: 12,
              color: (theme) => theme.palette.grey[500]
            }}>
            <MdClose fontSize="small" />
          </IconButton>

          <DialogTitle id="alert-dialog-title" sx={{ pb: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5, pt: 2 }}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: (theme) => theme.palette.primary.light,
                  color: (theme) => theme.palette.primary.main
                }}>
                <BiLock fontSize="large" />
              </Box>
              <Typography variant="h5" fontWeight={600} textAlign="center">
                Forgot Password?
              </Typography>
              <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ maxWidth: 340 }}>
                Enter the email address linked to your account and we&apos;ll send you a link to reset
                your password.
              </Typography>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ px: { xs: 2, sm: 4 }, pt: 3 }}>
            <UserTextInput
              label={'Email'}
              control={control}
              name="email"
              type="text"
              placeholder="Enter your email"
              sx={{ marginTop: '5px' }}
            />
          </DialogContent>

          <DialogActions sx={{ px: { xs: 2, sm: 4 }, pb: 3, pt: 1, gap: 1.5 }}>
            <Button variant="outlined" onClick={handleClose} sx={{ borderRadius: 2, px: 3, py: 1 }}>
              Cancel
            </Button>

            <PrimaryButton type="submit" title={isLoading ? 'Loading..' : 'Submit'} />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default ForgotPasswordModal;
